<template>
	<div style="padding: 12px; padding-top: 0; height: 100%">
		<!-- <el-card
			v-if="announcementList && announcementList.length > 0 && !difChannelType.isFullScreen"
			class="gg-card"
			style="height: 99%">
			<div class="u-flex-col" style="width: 100%; height: 100%">
				<div class="u-flex u-row-between">
					<h4 style="font-weight: initial">通知公告</h4>
					<el-button v-if="announcementList.length > 3" type="text" @click="moreAnnouncementFlag = true">
						查看更多>
					</el-button>
				</div>
				<el-divider style="height: 0.5px"></el-divider>

				<div class="content-gg">
					<div v-if="announcementList[0].type == 2" class="left-new-contnet" style="padding: 0 0 0 0; cursor: initial">
						<div style="width: 100%; height: 55%; position: relative">
							<img
								:src="announcementList[0].bannerImage || 'https://file.meibaokeji.com/assets/images/wei_fl_bg.png'"
								alt=""
								style="width: 100%; height: 100%" />
							<div
								style="
									position: absolute;
									top: 5%;
									left: 50%;
									transform: translateX(-50%);
									font-size: 24px;
									font-weight: bold;
								">
								{{ announcementList[0].title || '' }}
							</div>
							<div
								style="
									position: absolute;
									top: 20%;
									left: 50%;
									transform: translateX(-50%);
									width: 82%;
									height: 71%;
									display: flex;
									flex-wrap: wrap;
									justify-content: space-between;
									overflow: auto;
								">
								<template v-for="(item, index) in announcementList[0].extra">
									<div :key="index" style="width: 49.5%; height: fit-content" v-html="item.value"></div>
								</template>
							</div>
						</div>
						<div style="padding: 24px; height: 100%">
							<div class="u-flex" style="margin-top: 20px">
								<div style="font-size: 20px; font-weight: bold">
									{{ announcementList[0].title || '' }}
								</div>
							</div>
							<div style="margin-top: 24px; color: #949aad; height: 61%; overflow: auto">
								{{ announcementList[0].description || '' }}
							</div>
							<div style="color: #949aad">
								{{ announcementList[0].updateTime || '' }}
							</div>
						</div>
					</div>
					<div v-else class="left-new-contnet" @click="readAnnouncement(announcementList[0])">
						<img
							:src="announcementList[0].bannerImage || 'https://file.meibaokeji.com/assets/images/home_gg_img.png'"
							alt=""
							style="width: 100%; height: 55%" />
						<div class="u-flex" style="margin-top: 20px">
							<div style="font-size: 20px; font-weight: bold">
								{{ announcementList[0].title || '' }}
							</div>
							<el-tag v-if="announcementList[0].readFlag == 0" effect="dark" style="margin-left: 8px" type="danger">
								未读
							</el-tag>
						</div>
						<div style="margin-top: 24px; color: #949aad; height: 24%; overflow: auto">
							{{ announcementList[0].description || '' }}
						</div>
						<div style="color: #949aad">
							{{ announcementList[0].updateTime || '' }}
						</div>
					</div>
					<div class="right-content">
						<template v-for="(item, index) in announcementList">
							<div
								v-if="index != 0 && index < 4"
								:key="index"
								:style="{'border-bottom': index != 3 ? '1px solid #e6e6e6' : ''}"
								class="u-flex-col"
								style="padding: 24px; height: 33.33%; cursor: pointer"
								@click="readAnnouncement(item)">
								<div class="u-flex">
									<div style="font-size: 20px; font-weight: bold">
										{{ item.title || '' }}
									</div>
									<el-tag v-if="item.readFlag == 0" effect="dark" style="margin-left: 8px" type="danger">未读</el-tag>
								</div>
								<div style="margin-top: 24px; color: #949aad; height: 55%; overflow: auto">
									{{ item.description || '' }}
								</div>
								<div style="color: #949aad">
									{{ item.updateTime || '' }}
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</el-card> -->

		<!-- 重要公告和费率公告 -->
		<div
			v-if="
				((announcementList.length > 0 && announcementList[0].type == 2) || newsImg.length > 0) &&
				!difChannelType.isFullScreen
			"
			class="gg-card"
			style="height: 99%">
			<div class="u-flex u-row-between" style="height: 100%; align-items: flex-start" v-if="newsImg.length > 0">
				<div
					class="gg_card_content u-flex-col"
					style="max-height: 100%"
					v-if="newsImg.length > 0"
					:style="{
						width: !(announcementList.length > 0 && announcementList[0].type == 2) ? '100%' : 'calc(50% - 10px)',
					}">
					<div class="gg_card_header">
						<span class="gg_card_title">重要公告</span>
						<div class="u-flex gg_card_more" v-if="newsImg.length > 2" @click="onToNews(newsImg[0], 0)">更多 ></div>
					</div>
					<div class="gg_card_content_list">
						<el-card v-for="(item, index) in newsImg" class="u-margin-bottom-12" :key="index" style="width: 100%">
							<div class="gg_card_item" @click="onToNews(item, index)">
								<div class="image-wrapper" v-if="item.coverImage">
									<el-image :src="item.coverImage" style="width: 100%; height: 100%"></el-image>
								</div>
								<div class="gg_card_item_title">
									{{ item.name }}
								</div>
								<div class="u-flex u-col-center u-margin-top-4" style="font-size: 14px; color: #999">
									<i style="margin-right: 4px" class="el-icon-date"></i>
									{{ item.effectBegin.substring(0, 10) }}
								</div>
							</div>
						</el-card>
					</div>
				</div>

				<div
					class="gg_card_content u-flex-col"
					style="max-height: 100%; overflow: auto"
					v-if="announcementList.length > 0 && announcementList[0].type == 2"
					:style="{
						width: !(newsImg.length > 0) ? '100%' : 'calc(50% - 10px)',
					}">
					<div class="gg_card_header">
						<span class="gg_card_title">费率公告</span>
					</div>
					<div class="gg_card_content_list">
						<el-card style="width: 100%">
							<div class="gg_card_item" style=" height: calc(100vh - 280px);">
								<div style="width: 100%; height: 100%; position: relative">
									<img
										:src="announcementList[0].bannerImage || 'https://file.meibaokeji.com/assets/images/wei_fl_bg.png'"
										alt=""
										style="width: 100%; height: 100%" />
									<div
										style="
											position: absolute;
											top: 5%;
											left: 50%;
											transform: translateX(-50%);
											font-size: 18px;
											font-weight: bold;
										">
										{{ announcementList[0].title || '' }}
									</div>
									<div
										style="
											position: absolute;
											top: 20%;
											left: 50%;
											transform: translateX(-50%);
											width: 82%;
											height: 71%;
											display: flex-col;
											overflow: auto;
										">
										<template v-for="(item, index) in announcementList[0].extra">
											<div :key="index" style="width:100%; height: fit-content" v-html="item.value"></div>
										</template>
									</div>
								</div>

								<div class="gg_card_item_title">{{ announcementList[0].title || '' }}</div>
								<div style="margin-top: 12px; color: #949aad; height: 61%; overflow: auto">
									{{ announcementList[0].description || '' }}
								</div>
								<div class="u-flex u-col-center u-margin-top-12" style="font-size: 14px; color: #999">
									<i style="margin-right: 4px" class="el-icon-date"></i>
									{{ announcementList[0].updateTime.substring(0, 10) }}
								</div>
							</div>
						</el-card>
					</div>
				</div>
			</div>
		</div>

		<el-card v-else style="height: calc(100% - 20px)">
			<div class="banner-text">
				<img src="images/welcome.png" />
				<br />
				<div style="display: flex; justify-content: center; margin-top: 10px; font-size: 14px">
					<span v-if="versionCode && versionCode !== ''">版本号：{{ versionCode }}</span>
				</div>
			</div>
		</el-card>

		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:visible.sync="isShowNews"
			append-to-body
			destroy-on-close
			class="news-dialog"
			top="2vh"
			width="55%">
			<div
				class="u-flex-col"
				style="position: relative"
				@mouseenter="newsAutoplay = false"
				@mouseleave="newsAutoplay = true">
				<div
					style="
						position: absolute;
						top: 12px;
						right: 12px;
						z-index: 99;
						font-size: 20px;
						color: #fff;
						cursor: pointer;
					">
					<i v-show="countNum == 0" class="el-icon-close" @click="onCloseNews"></i>
					<span v-show="countNum != 0" style="color: #333">{{ countNum }}</span>
				</div>

				<el-carousel
					ref="carouselImg"
					height="90vh"
					indicator-position="none"
					@change="onChange"
					:autoplay="newsAutoplay">
					<el-carousel-item v-for="itemData in newsImg" :key="itemData.id">
						<div class="u-flex-col">
							<div class="changeBg-content u-flex u-row-start u-col-center" style="padding: 20px">
								<span style="font-size: 15px; font-weight: bold; color: #333">重要公告</span>
							</div>

							<div
								class="u-flex-col u-col-center"
								style="
									width: 100%;
									background: #fff;
									padding: 12px 36px 36px 36px;
									height: 80vh;
									overflow: auto;
									position: relative;
									align-items: flex-start;
								">
								<div class="u-flex-col">
									<div style="font-size: 16px; font-weight: bold; color: #333">{{ itemData.name }}</div>
									<div
										class="u-flex u-col-center u-margin-top-8"
										style="justify-content: flex-start; font-size: 14px; color: #999; width: 100%">
										<i style="margin-right: 4px; transform: translateY(1px)" class="el-icon-date"></i>
										{{ itemData.effectBegin.substring(0, 10) }}
									</div>
								</div>
								<el-divider></el-divider>

								<div
									:style="{height: itemData.fileCollect && itemData.fileCollect.length > 0 ? '22vw' : '72vw'}"
									style="width: 100%; overflow: auto"
									v-html="itemData.html"></div>

								<el-divider v-if="itemData.fileCollect && itemData.fileCollect.length > 0"></el-divider>

								<div style="width: 100%; height: 20vh">
									<div
										class="u-flex-col file-list-container"
										v-if="itemData.fileCollect && itemData.fileCollect.length > 0"
										style="width: 100%; height: 9vw; overflow: auto">
										<div class="xg_title">
											<span>相关文件</span>
										</div>
										<div
											v-for="(o, oIndex) in itemData.fileCollect"
											:key="oIndex"
											:style="{'margin-top': oIndex > 0 ? '12px' : '0'}"
											class="u-flex u-row-between">
											<div class="u-flex u-col-center">
												<img :src="getFileIcon(o.url)" style="width: 24px; height: 24px; margin-right: 8px" alt="" />
												<span>{{ o.name }}</span>
											</div>
											<el-button type="text" @click="openFile(o.url)">查看</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
				<div
					class="u-flex bottom_text"
					style="position: absolute; z-index: 999; bottom: 2px; cursor: pointer; height: 60px; width: 100%">
					<div
						v-for="(itemData, index) in newsImg"
						:key="itemData.id"
						:class="{changeBg: newsImg[currentIndex].id === itemData.id}"
						:style="{width: 100 / newsImg.length + '%'}"
						class="u-flex u-row-center u-col-center bottom_content"
						@click="setActiveItem(index)">
						{{ itemData.name }}
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="readData.title" :visible.sync="readFlag" append-to-body top="5vh" width="60%">
			<div style="height: 75vh; overflow: auto">
				<div v-html="readData.content"></div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="moreAnnouncementFlag" append-to-body title="通知公告" top="5vh" width="62%">
			<template v-for="(item, index) in announcementList">
				<div
					v-if="item.type == 1"
					:key="index"
					:style="{'border-bottom': index != announcementList.length - 1 ? '1px solid #e6e6e6' : ''}"
					class="u-flex-col"
					style="padding: 24px; cursor: pointer"
					@click="readAnnouncement(item)">
					<div class="u-flex">
						<div style="font-size: 20px; font-weight: bold">{{ item.title || '' }}</div>
						<el-tag v-if="item.readFlag == 0" effect="dark" style="margin-left: 8px" type="danger">未读</el-tag>
					</div>
					<div style="margin-top: 24px; color: #949aad; height: 200px; overflow: auto">
						{{ item.description || '' }}
					</div>
					<div style="color: #949aad">{{ item.updateTime || '' }}</div>
				</div>
			</template>
		</el-dialog>

		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:visible.sync="isShowNzzj"
			append-to-body
			class="year-report-dialog">
			<div class="year_report_main">
				<div
					class="close-icon"
					style="
						position: absolute;
						top: 12px;
						right: -42px;
						z-index: 99;
						font-size: 28px;
						color: #fff;
						cursor: pointer;
					">
					<i class="el-icon-close" @click="onCloseNzzj"></i>
				</div>

				<newYearReportModal></newYearReportModal>
			</div>
		</el-dialog>

		<!--    <el-dialog :visible.sync="isShowOtherNotices" append-to-body top="2vh" width="42%">-->
		<!--      <div>-->
		<!--        <el-alert description="本次结算申请正在进行中，记得提醒主渠道管理员及时提交申请！" title="申请结算" type="success"></el-alert>-->
		<!--        <el-divider></el-divider>-->

		<!--        <el-alert description="为了出单后便捷的进行结算操作，请及时完善结算信息！" title="完善结算信息" type="warning">-->
		<!--        </el-alert>-->
		<!--        <div class="u-m-t-20 u-flex u-row-center" style="width: 100%">-->
		<!--          <el-button type="primary" @click="onToSettleInfo">立即完善</el-button>-->
		<!--        </div>-->
		<!--        <el-divider></el-divider>-->

		<!--        <el-alert description="`您有${dateNum[0]}条保单将于3日内到期，${dateNum[1]}条保单将于7日内到期，请及时进行续保操作！`" title="续保" type="warning">-->
		<!--        </el-alert>-->
		<!--        <div class="u-m-t-20 u-flex u-row-center" style="width: 100%">-->
		<!--          <el-button type="primary" @click="onToSettleInfo">去续保</el-button>-->
		<!--        </div>-->

		<!--      </div>-->
		<!--    </el-dialog>-->

		<InsureNotices
			ref="refInsureNotices"
			:is-can-close="false"
			@onToCancel="onToSureEnd(0)"
			@onToSureEnd="onToSureEnd(1)"></InsureNotices>
	</div>
</template>

<script>
import newYearReportModal from '@/components/ui/newYearReportModal.vue'
import {mapGetters} from 'vuex'
import config from '../../version.json'
import {getAnnouncementIndex, getNewsEnable, readAnnouncementIndex} from '@/api/insurance/news'

import {huisuAble} from '@/mixins/huisuAble'
import {initializeHints, onHintYearSummary} from '@/util/welHintUtil'
import InsureNotices from 'meibao-insure/src/components/InsureNotices.vue'
import {addUserLog} from '@/api/admin/log'
import {EnumLogType} from '@/const/enum'
import {isChannel} from '@/util/channelUtil'
import {getFileIcon} from '@/util/util'
import sensors from 'sa-sdk-javascript'

export default {
	name: 'Wel',
	data() {
		return {
			yearEndPosterUrl: '',
			activeNames: ['1', '2', '3', '4'],
			DATA: [],
			text: '',
			isShowNzzj: false, // 是否展示年终总结海报
			actor: '',
			announcementList: [],
			count: 0,
			isText: false,
			moreAnnouncementFlag: false,
			showHintData: null,
			readData: {},
			readFlag: false,
			showHintNum: 0,
			versionCode: config.version,
			isShowNews: false,
			newsAutoplay: true, //是否自动播放
			newsImg: [], //重要公告
			countNum: 5,
			countTimeInterval: null,
			countTimeIntervalData: null,
			currentIndex: 0,
			//整合提醒
			isShowOtherNotices: false,
		}
	},
	components: {InsureNotices, newYearReportModal},
	computed: {
		...mapGetters(['website', 'roles', 'isShowSettleHint', 'userInfo', 'difChannelType']),
	},
	created() {
		//初始化通知公告
		this.initTz()
	},
	mixins: [huisuAble],
	mounted() {
		try {
			//如果不是渠道，则直接返回
			if (!isChannel()) {
				return
			}
			if (this.envConfig.isBxIe()) {
				//吉泰提醒
				// onHintJtNotices().then((resNotices) => {
				//   this.$refs.refInsureNotices.onShowNotices(resNotices)
				// }).catch((error) => {
				//   console.error(error)
				//   this.onToSureEnd(0)
				// })
				//暂时隐藏博维和吉泰切换条款
				this.onToSureEnd(0)
			} else {
				//xsm
				this.getNewsData()
			}
		} catch (e) {
			console.error(e)
		}
	},

	methods: {
		onToNews(item, index) {
			console.log('onToNews', item, index)
			// 找到点击的item在newsImg数组中的索引
			const targetIndex = index

			if (targetIndex !== -1) {
				// 设置当前索引
				this.currentIndex = targetIndex

				// 打开弹框
				this.isShowNews = true

				// 设置倒计时为0，直接显示关闭按钮
				this.countNum = 0

				// 清除可能存在的倒计时定时器
				if (this.countTimeInterval) {
					clearInterval(this.countTimeInterval)
					this.countTimeInterval = null
				}

				// 使用nextTick确保DOM更新后再设置轮播位置
				this.$nextTick(() => {
					if (this.$refs.carouselImg) {
						this.$refs.carouselImg.setActiveItem(targetIndex)
					}
				})

				// 添加埋点，记录用户点击推广通知的行为
				const sensorData = {
					relation_id: item.id,
					relation_title: item.name,
					sequence_id: targetIndex + 1,
				}
				sensors.track('ie_insu_notice_item_click', sensorData)
			}
		},
		onToSureEnd(type = 0) {
			try {
				if (type) {
					addUserLog(EnumLogType.logInsureNotices, {eventStatus: '1', eventKey: EnumLogType.logInsureNotices})
				}
				//弹出年度总结
				// onHintYearSummary()
				// 	.then((resUrl) => {
				// 		sensors.track('ie_annual_report_popup_display', {})
				// 		//弹出
				// 		this.isShowNzzj = true
				// 	})
				// 	.catch(() => {
				// 	})
				//下一步推广新闻
				this.getNewsData()
			} catch (e) {
				console.error(e)
			}
		},
		//关闭展示年终总结
		onCloseNzzj() {
			sensors.track('ie_annual_report_popup_view_click', {button_name: '关闭'})
			this.isShowNzzj = false
			this.getNewsData()
		},
		getData() {
			if (this.count < this.DATA.length - 1) {
				this.count++
			} else {
				this.count = 0
			}
			this.isText = true
			this.actor = this.DATA[this.count]
		},
		setData() {
			let num = 0
			let count = 0
			let active = false
			const timeoutstart = 5000
			const timeoutend = 1000
			const timespeed = 10
			this.countTimeIntervalData = setInterval(() => {
				if (this.isText) {
					if (count == this.actor.length) {
						active = true
					} else {
						active = false
					}
					if (active) {
						num--
						this.text = this.actor.substr(0, num)
						if (num == 0) {
							this.isText = false
							setTimeout(() => {
								count = 0
								this.getData()
							}, timeoutend)
						}
					} else {
						num++
						this.text = this.actor.substr(0, num)
						if (num == this.actor.length) {
							this.isText = false
							setTimeout(() => {
								this.isText = true
								count = this.actor.length
							}, timeoutstart)
						}
					}
				}
			}, timespeed)
		},
		openFile(url) {
			//新的窗口打开文件
			window.open(url)
		},
		// 获取文件图标
		getFileIcon(url) {
			return getFileIcon(url)
		},
		//阅读公告
		readAnnouncement(row) {
			//获取下标
			const index = this.announcementList.findIndex((item) => item.id === row.id)
			let sensorData = {
				relation_id: row.id,
				relation_title: row.title,
				sequence_id: index + 1,
			}
			console.log('sensorData', sensorData)
			sensors.track('ie_insu_notice_item_click', sensorData)

			if (row.readFlag == 0) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
				})
				readAnnouncementIndex(row.id).then((res) => {
					loading.close()
					if (res.status == 200 && res.data.code == 0) {
						this.initTz()
					}
				})
			}
			//打开阅读公告模态框
			this.readData = {...row}
			this.readFlag = true
		},
		getNewsData() {
			// 用于检查和更新每日访问记录的工具函数
			const getDailyVisitCount = () => {
				const today = new Date().toDateString()
				const visitRecord = JSON.parse(localStorage.getItem('newsVisitRecord') || '{}')

				if (visitRecord.date !== today) {
					// 新的一天，重置访问记录
					const newRecord = {date: today, count: 0}
					localStorage.setItem('newsVisitRecord', JSON.stringify(newRecord))
					return 0
				}

				return visitRecord.count
			}
			const incrementVisitCount = () => {
				const today = new Date().toDateString()
				const visitRecord = JSON.parse(localStorage.getItem('newsVisitRecord') || '{}')
				const newRecord = {
					date: today,
					count: visitRecord.date === today ? visitRecord.count + 1 : 1,
				}
				localStorage.setItem('newsVisitRecord', JSON.stringify(newRecord))
				return newRecord.count
			}
			//判断权限
			let {distAccount} = this.userInfo
			if (!this.validatenull(distAccount)) {
				let {channelId = '', mainChannelId = ''} = distAccount
				if (channelId && mainChannelId) {
					//根据接口判断
					getNewsEnable({status: 1})
						.then((resNews = {}) => {
							let {records = []} = resNews.data.data || {}
							if (records.length > 0) {
								// 获取并更新访问次数
								const visitCount = getDailyVisitCount()
								incrementVisitCount()
								// 处理新闻数据
								this.newsImg = records.map((item) => ({
									...item,
									fileCollect: JSON.parse(item.fileCollect),
								}))
								console.log('this.newsImg', this.newsImg)
								this.isShowNews = true

								// 添加埋点，记录默认展示的第一条内容
								if (this.newsImg && this.newsImg.length > 0) {
									const firstItem = this.newsImg[0]
									const sensorData = {
										relation_id: firstItem.id,
										relation_title: firstItem.name,
									}
									sensors.track('ie_insu_notice_popup_banner_view', sensorData)
								}

								// 根据访问次数决定显示逻辑
								if (visitCount === 0) {
									// 第一次访问，显示倒计时
									this.countNum = 5 // 设置初始倒计时时间
									this.countTimeInterval = setInterval(() => {
										this.countNum--
										if (this.countNum === 0) {
											if (this.countTimeInterval) {
												clearInterval(this.countTimeInterval)
												this.countTimeInterval = null
											}
										}
									}, 1000)
								} else {
									// 非第一次访问，直接显示关闭按钮
									this.countNum = 0
								}
							} else {
								// 没有新闻数据时显示结算提示
								initializeHints()
							}
						})
						.catch(() => {
							//展示 结算提示
							initializeHints()
						})
				}
			}
		},
		onCloseNews() {
			if (this.countNum !== 0) {
				return
			}
			this.isShowNews = false
			//展示 结算提示
			initializeHints()
		},
		//幻灯片
		onChange(current, last) {
			if (!this.isShowNews) {
				return
			}
			this.currentIndex = current

			// 添加埋点，记录轮播浏览行为
			if (this.newsImg && this.newsImg.length > 0 && this.newsImg[current]) {
				const currentItem = this.newsImg[current]
				const sensorData = {
					relation_id: currentItem.id,
					relation_title: currentItem.name,
				}
				sensors.track('ie_insu_notice_popup_banner_view', sensorData)
			}
		},
		setActiveItem(index) {
			if (this.$refs.carouselImg) {
				this.$refs.carouselImg.setActiveItem(index)
			}

			// 添加埋点，记录用户点击切换轮播的行为
			// onChange方法会在轮播切换后自动触发，所以这里不需要重复添加埋点
		},
		//格式化通知公告的数据
		forMatterAnnouncemnt(list) {
			let listData = list
			//先进行排序把 type=2的放在数组最前面，然后把 type=2的数据只保留一个，根据 sort 字段最小的，如果 sort 都一样，根据updateTime 时间，最新的时间存在
			// 首先，过滤出 type=2 的数据
			let type2Data = list.filter((item) => item.type === 2)
			// 如果有多个 type=2 数据，进行排序和筛选
			if (type2Data.length > 1) {
				type2Data.sort((a, b) => {
					// 先根据 sort 排序
					if (a.sort !== b.sort) {
						return a.sort - b.sort
					}
					// 如果 sort 相同，则根据 updateTime 排序（降序）
					let dateA = new Date(a.updateTime),
						dateB = new Date(b.updateTime)
					return dateB - dateA
				})
				// 只保留排序后的第一个 type=2 数据
				type2Data = type2Data.slice(0, 1)
			}

			// 过滤掉剩余 type=2 的数据
			let otherTypesData = list.filter((item) => item.type !== 2)

			// 合并 type=2 的数据和其他类型的数据
			listData = [...type2Data, ...otherTypesData]

			listData = listData.map((item) => {
				let obj = {...item}
				//如果是费率类型的需要解析 extra 的数据
				if (item.type == 2) {
					obj.extra = obj.extra ? JSON.parse(obj.extra) : []
				}
				return obj
			})

			return listData
		},
		//初始化通知公告!
		async initTz() {
			let res = await getAnnouncementIndex({
				pageNo: 1,
				size: 99,
			})
			if (res.status == 200 && res.data.code == 0 && res.data.data && res.data.data.records) {
				this.announcementList = this.forMatterAnnouncemnt(res.data.data.records)
			}
		},
	},
	// 添加 beforeDestroy 生命周期钩子
	beforeDestroy() {
		// 清理定时器
		if (this.countTimeInterval) {
			clearInterval(this.countTimeInterval)
			this.countTimeInterval = null
		}
		if (this.countTimeIntervalData) {
			clearInterval(this.countTimeIntervalData)
			this.countTimeIntervalData = null
		}
		// 清理新闻自动播放
		this.newsAutoplay = false
	},
}
</script>

<style lang="scss" scoped="scoped">
.content-gg {
	width: 100%;
	border: 1px solid #e6e6e6;
	height: 100%;
	display: flex;

	.left-new-contnet {
		width: 55%;
		padding: 24px;
		cursor: pointer;
		border-right: 1px solid #e6e6e6;
		display: flex;
		flex-direction: column;
	}

	.right-content {
		display: flex;
		width: 45%;
		flex-direction: column;
	}
}

.gg-card {
}

.el-collapse-item__header {
	display: block !important;
}

.wel-contailer {
	position: relative;
}

.banner-text {
	height: 100%;
	position: relative;
	padding: 50px 20px;
	font-size: 20px;
	text-align: center;
	color: #333;
}

.banner-img {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0.8;
	display: none;
}

.actor {
	height: 250px;
	overflow: hidden;
	font-size: 18px;
	color: #333;
}

.actor:after {
	content: '';
	width: 3px;
	height: 25px;
	vertical-align: -5px;
	margin-left: 5px;
	background-color: #333;
	display: inline-block;
	animation: blink 0.4s infinite alternate;
}

.typeing:after {
	animation: none;
}

@keyframes blink {
	to {
		opacity: 0;
	}
}
.xg_title {
	margin-bottom: 24px;
	font-size: 16px;
	color: #333;
	font-weight: bold;
	display: flex;
	align-items: center;
	&::before {
		content: '';
		width: 4px;
		height: 16px;
		background: #0771ff;
		display: block;
		margin-right: 6px;
	}
}
.news-dialog {
	::v-deep .el-dialog {
		background: transparent !important;
	}

	::v-deep .el-dialog__body {
		padding: 0 !important;
		border-radius: 12px !important;
	}

	::v-deep .el-dialog__header {
		display: none !important;
	}
}

::v-deep .el-carousel__item {
	background: transparent !important;
	box-shadow: transparent !important;
	border-color: transparent !important;
}
::v-deep .el-carousel {
	border-radius: 14px;
}

//<div style="border-radius: 100px;font-weight: bold;font-size: 20px;color: #1e9fff">2</div>
.time_count {
	height: 38px;
	width: 38px;
	background: rgba(146, 146, 146, 0.8);
	border-radius: 100px;
	border: 2px solid #888888;
	font-size: 26px;
	font-weight: bold;
	color: #d7d7d7;
	align-items: center;
	text-align: center;
}

.btn_custom {
	position: absolute;
	z-index: 10;
	top: 0;
	margin-top: 15px;
	cursor: pointer;
}

.btn_download {
	left: 0;
	margin-left: 15px;
}

.btn_close {
	right: 0;
	margin-right: 15px;
}

.bottom_text {
	background-color: rgba(98, 99, 100, 0.95);
}

::v-deep .el-divider--horizontal {
	margin: 12px 0;
}

.bottom_content {
	padding: 12px;
	color: #f3f2f2;
	text-align: center;
	font-size: 13px;
	display: flex;
	align-items: center;
	justify-content: center;
	//   overflow: hidden;
	//   white-space: nowrap;
	height: 100%;
	overflow: hidden;
	word-break: break-all;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	// display: -webkit-box;
	-webkit-box-orient: vertical;
}

.pointer {
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
}

.changeBg {
	background-color: #409eff;
	color: #fff;
	font-size: 14px;
	height: 100%;
	transition: all 0.5s;
	font-weight: bold;
}
.changeBg-content {
	position: relative;
	background: #ffe3cd;
	color: #333;
	&::before {
		content: '';
		position: absolute;
		top: -2px;
		right: 0px;
		width: 130px;
		height: 87px;
		background: url('https://file.meibaokeji.com/safety/img/tg_popup_header.png') no-repeat;
		background-size: 100% 100%;
	}
}

::v-deep .el-carousel__arrow {
	height: 45px;
	width: 45px;
	background-color: rgba(31, 45, 61, 0.51);
}

::v-deep .el-carousel__arrow i {
	font-size: 20px;
}

/* 文件列表容器滚动条美化 - 简约风格 */
.file-list-container::-webkit-scrollbar {
	width: 4px;
	height: 4px;
}

.file-list-container::-webkit-scrollbar-track {
	background: transparent;
}

.file-list-container::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.15);
	border-radius: 2px;
	transition: all 0.2s ease;
}

.file-list-container::-webkit-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, 0.25);
}

/* Firefox 滚动条样式 */
.file-list-container {
	scrollbar-width: thin;
	scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
}

.gg_card_content {
	border-radius: 12px;
	max-height: 100%;
	background-color: #fff;
	overflow: auto;
	.gg_card_header {
		padding: 20px 16px;
		display: flex;
		border-bottom: 1px solid #e6e6e6;
		justify-content: space-between;
		background: linear-gradient(180deg, #ffe3cd -16%, #ffffff 84%), #f1efee;
		.gg_card_title {
			font-size: 18px;
			color: #333;
			font-weight: bold;
			display: flex;
			align-items: center;
			&::before {
				content: '';
				width: 4px;
				height: 16px;
				background: #0771ff;
				display: block;
				margin-right: 6px;
			}
		}
		.gg_card_more {
			font-size: 13px;
			font-weight: bold;
			color: #999;
			cursor: pointer;
			&:hover {
				opacity: 0.8;
			}
		}
	}
	.gg_card_content_list {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 8px 12px 24px 12px;
		.gg_card_item {
			width: 100%;
			// height: calc(100vh - 280px);
			overflow: auto;
			background: #fff;
			padding: 0 12px 0 12px;
			transition: all 0.3s ease;
			cursor: pointer;
			&:hover {
				opacity: 0.8;
			}
			margin-bottom: 12px;
			.gg_card_item_title {
				margin-top: 12px;
				font-size: 16px;
				color: #333;
				font-weight: bold;
			}
			.image-wrapper {
				width: 100%;
				height: 0;
				padding-bottom: 43%;
				position: relative;
				overflow: hidden;
				border-radius: 8px;
				.el-image {
					position: absolute;
					top: 0;
					left: 0;
				}
			}
		}
	}
}
</style>
